import { TAGS } from "../constants";
import {
  ProviderAvailability,
  ProviderAvailabilityInsert,
  ProviderAvailabilityUpdate,
  TimeSlot,
} from "../types";
import { api } from "./api";

export const availabilityApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getProviderAvailabilities: builder.query<
      {
        data: ProviderAvailability[];
        count: number;
      },
      {
        provider_id?: number;
        first_name?: string;
        last_name?: string;
        from: number;
        to: number;
        date_from?: string;
        date_to?: string;
      }
    >({
      query: (params) => ({
        url: "/api/provider-availability",
        method: "GET",
        params,
      }),
      providesTags: [TAGS.PROVIDER_AVAILABILITY],
    }),

    createAvailability: builder.mutation<
      ProviderAvailability,
      ProviderAvailabilityInsert
    >({
      query: (body) => ({
        url: `/api/provider-availability`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _error, args) => [
        { type: TAGS.PROVIDER_AVAILABILITY, id: args.provider_id },
        TAGS.PROVIDER_AVAILABILITY,
        TAGS.TIME_SLOTS,
      ],
    }),

    updateAvailability: builder.mutation<
      ProviderAvailability,
      {
        availability_id: number;
        body: ProviderAvailabilityUpdate;
      }
    >({
      query: ({ availability_id, body }) => ({
        url: `/api/provider-availability/${availability_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, args) => [
        { type: TAGS.PROVIDER_AVAILABILITY, id: args.availability_id },
        TAGS.PROVIDER_AVAILABILITY,
        TAGS.TIME_SLOTS,
      ],
    }),

    getProviderTimeSlots: builder.query<
      { data: TimeSlot[]; count: number },
      {
        availability_id?: number;
        status?: string;
        from: number;
        to: number;
      }
    >({
      query: ({ availability_id, ...params }) => ({
        url: `/api/provider-availability/${availability_id}/time-slots`,
        method: "GET",
        params,
      }),
      providesTags: (_returns, _error, args) => [
        { type: TAGS.TIME_SLOTS, id: args.availability_id },
      ],
    }),

    cancelTimeSlot: builder.mutation<
      TimeSlot,
      { id: number; providerAvailabilityId: number }
    >({
      query: ({ id }) => ({
        url: `/api/time-slots/${id}/cancel`,
        method: "POST",
      }),
      invalidatesTags: (_result, _error, args) => [
        { type: TAGS.TIME_SLOTS, id: args.providerAvailabilityId },
      ],
    }),
  }),
});

export const {
  useGetProviderAvailabilitiesQuery,
  useCreateAvailabilityMutation,
  useUpdateAvailabilityMutation,
  useGetProviderTimeSlotsQuery,
  useCancelTimeSlotMutation,
} = availabilityApi;
